import React, { useState, useEffect } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import License from '../components/license/license';
import '../assets/css/econfig-app.css';
import Loader from '../components/loader/loader';
import { CountryItem } from '../models/countryItemModel';

const MainWrapper = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  var uiUrl = 'https://knowledgebridge.engineer/modelView/';
  var apiUrl = 'https://knowledgebridge.engineer/api/';
  var eConfigGatewayAPI = "";
  var eConfigSubscriptionKey = "";
  var URL = window.location.href;
  if (URL.includes("dev") || URL.includes("localhost")) {
    eConfigGatewayAPI = "https://apidev.parker.com/dev/econfigplus";
    // eConfigGatewayAPI = "http://localhost:51900";
    eConfigSubscriptionKey = "786ac6edd2444f53a6e2ed8757709baa";
  } else if (URL.includes("test")) {
    eConfigGatewayAPI = "https://apidev.parker.com/test/econfigplus";
    eConfigSubscriptionKey = "d152a1b2df3343df870bd7d81df4124f";
  } else if (URL.includes("preview")) {
    eConfigGatewayAPI = "https://api.parker.com/stage/econfigplus";
    eConfigSubscriptionKey = "65a90ff0e998468da0cc80bb7736d8ea";
  } else {
    eConfigGatewayAPI = "https://api.parker.com/prod/econfigplus";
    eConfigSubscriptionKey = "fb5ccb2dedf54509900c5d96a24718c6";
  }
  var sessionId = null;
  var tok = null;
  useEffect(() => {
    getIFrameUrl();
    getPDXPageViewData();
  }, []);
  async function getIFrameUrl() {
    let res;
    let data;
    try {
      res = await loginToKB();
      if (res.status === 200) {
        data = await res.json();
        tok = 'Bearer ' + data.access_token;
      }
    } catch (e) {
      return null;
    };
    try {
      res = undefined;
      data = undefined;
      res = await initKBSession();
      if (res.status === 200) {
        data = await res.json();
        sessionId = data.sessionId;
        uiUrl = uiUrl + sessionId;
        var iframeid = document.getElementById("iframeid");
        iframeid.src = uiUrl;
        iframeid.onload = () => {
          setIsLoaded(true);
          setShowModal(true);
        }
      }
    } catch (e) {
      return null;
    }
    return uiUrl;
  }
  // Log in to KB
  async function loginToKB() {
    try {
      return fetch(`${eConfigGatewayAPI}/LoginKB/AuthenticateKBLogin`, { headers: { "Ocp-Apim-Subscription-Key": eConfigSubscriptionKey } });
    } catch (e) {

    }
  }

  //get Session Data for PDX Page View
  async function getPDXPageViewData() {
    let sessionResponse;
    // Retrieve the previous URL from the cookie (if available)
    let previousURL = getCookie("previousURL");
    // Set the current page's URL as the new previous URL in the cookie
    document.cookie = "previousURL=" + encodeURIComponent(window.location.href) + ";domain=parker.com;path=/";
    sessionResponse = await getSessionData();
    if (sessionResponse !== undefined) {
      if (sessionResponse.status === 200) {
        let data = await sessionResponse.json();
        let countryCheck = new CountryItem();
        let countryID = countryCheck.CountryList.filter((country) => country.CountryID.toLowerCase() === data.countryId.toLowerCase())[0].LangID;
        window["dataLayer"].push({
          event: 'page_view',
          page_name: data.manufacturingDivision + "-" + data.seriesName + "-PARKER E-CONFIGURATOR",
          page_referrer: previousURL == null ? 'N/A' : decodeURIComponent(previousURL),
          content_group: 'configurator',
          country: countryID.toUpperCase(),
          language: data.language.toUpperCase(),
          content_owner: data.manufacturingDivision,
          nav_owner: data.countryId,
          product_category_name: 'N/A',
          product_series_name: data.seriesName,
          product_id: data.productId,
          part_name: 'N/A',
          part_number: 'N/A',
          hit_timestamp: new Date().toISOString(),
          is_category_page: "No",
          is_series_page: "No",
          is_pdp: "No",
          event_timestamp_unix: new Date().toISOString(),
          is_req_quote: "No",
          is_wtb: "No",
          is_buyable_online: "No",
          is_configurable: 'N/A',
          product_series_id: 'N/A'
        });
      }
    }
  }

  // Function to get the value of a cookie by its name
  function getCookie(name) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split("=");
      if (cookie[0].trim() === name) {
        if (window.location.href === decodeURIComponent(cookie[1])) {
          return null;
        }
        return cookie[1];
      }
    }
    return null;
  }

  async function getSessionData() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get('ControlAndValueString');
      return fetch(`${eConfigGatewayAPI}/SessionData/${sessionId === "" ? null : sessionId}`, { headers: { "Ocp-Apim-Subscription-Key": eConfigSubscriptionKey } });
    } catch (e) {

    }
  }
  // With credentials already stored in token, initialize a new
  // KB session
  function initKBSession() {

    let bdata = {
      projectRevisionId: 'd00b936d-2936-47a8-522b-08de779034db', // Revision 0.11.0
      designName: 'Parker_Hannifin_ePump__Sizer'
    };
    let moptions = {
      method: 'POST',
      mode: 'cors',
      //credentials: 'include',
      headers: {
        Accept: 'application/json',
        Authorization: tok,
        'Content-Type': 'application/json',
        'api-version': '4.0',
        'current-kb-version': '4.0'
      },
      body: JSON.stringify(bdata)
    };

    return fetch(apiUrl + 'runtime/session/init', moptions);

  };
  function hideModal(hide) {
    setShowModal(hide);
  }

  return (
    <>
      <Loader show={isLoaded} />
      <Header />
      <div className="econfig-app">
        <div>
          <iframe frameBorder="0" allowFullScreen
            style={{ width: '100%', height: '770px' }} id="iframeid" src="" title='iframe' />
        </div>
      </div>
      <License show={showModal} hide={hideModal} />
      <Footer />
    </>
  );
}
export default MainWrapper